import React from "react";
import { Box, Dialog, DialogContent, DialogTitle, Divider, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import { COLORS, REACTION_COLORS, modalBackdropSlotProps } from "./colors";

const formatDate = (isoDate) => {
  const date = new Date(isoDate);
  const day = String(date.getUTCDate()).padStart(2, "0");
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  return `${day}-${month}-${date.getUTCFullYear()}`;
};

const SummaryStat = ({ icon, label, value }) => (
  <Box sx={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
    {icon}
    <Typography variant="body2" color="text.secondary">
      {label}:
    </Typography>
    <Typography variant="body2" sx={{ fontWeight: 700 }}>
      {value}
    </Typography>
  </Box>
);

const FullHistoryModal = ({ open, onClose, tip }) => {
  const sortedHistory = [...(tip.shownHistory || [])].sort((a, b) => new Date(b.date) - new Date(a.date));

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" slotProps={modalBackdropSlotProps}>
      <DialogTitle sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between" }}>
        <Box>
          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            Full Tip History
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {tip.title}
          </Typography>
        </Box>
        <IconButton size="small" onClick={onClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            bgcolor: REACTION_COLORS.insightful.bg,
            borderRadius: 1.5,
            p: 1.5,
            mb: 2,
          }}
        >
          <SummaryStat icon={<VisibilityIcon color="action" fontSize="small" />} label="Total views" value={tip.views} />
          <Divider orientation="vertical" flexItem />
          <SummaryStat icon={<AutorenewIcon color="action" fontSize="small" />} label="Times shown" value={tip.rotations} />
        </Box>

        <Box sx={{ display: "flex", justifyContent: "space-between", px: 0.5, pb: 1 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
            Date Shown
          </Typography>
          <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
            Views
          </Typography>
        </Box>
        <Divider />

        {sortedHistory.length === 0 && (
          <Typography variant="body2" color="text.secondary" sx={{ py: 2 }}>
            This tip has not been shown yet.
          </Typography>
        )}
        {sortedHistory.length > 0 && (
          <Box sx={{ maxHeight: 260, overflowY: "auto" }}>
            {sortedHistory.map((entry, index) => (
              <Box
                key={entry.date}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  px: 0.5,
                  py: 1.25,
                  borderBottom: index === sortedHistory.length - 1 ? "none" : "1px solid",
                  borderColor: COLORS.border,
                }}
              >
                <Typography variant="body2">{formatDate(entry.date)}</Typography>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                  {entry.viewsCount}
                </Typography>
              </Box>
            ))}
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default FullHistoryModal;
